import ApiService from './ApiService';
import NotificationService from './NotificationService';

export default class PromotionsService {
    static createdInstance = null;
    static getInstance() {
        if (PromotionsService.createdInstance === null) {
            PromotionsService.createdInstance = new PromotionsService();
        }
        return PromotionsService.createdInstance;
    }

    constructor() {
        this.apiService = ApiService.getInstance();
        this.notificationService = NotificationService.getInstance();
    }

    getPromotions(
        userId,
        coursesHeadingsId,
        productId,
        paymentMethodDVID,
        inInstallments,
        callback
    ) {
        const payload = {
            usersID: userId,
            coursesHeadingsID: coursesHeadingsId,
            productsID: productId,
            paymentMethodsDVIDList: paymentMethodDVID,

            localizationsID: '2',
            current_LocalizationsID: '0',
        };

        this.apiService.apiPost('GetPromotionDiscountsForCourseProductsID', payload, (response) => {
            if (response.success) {
                if (response.data.status === '200') {
                    const processed = this.prepareDiscounts(response.data.body, inInstallments);
                   
                    if (typeof callback === 'function') {
                        callback({ success: true, data: processed, fullData: response.data.body });
                    }
                } else {
                    if (typeof callback === 'function') {
                        callback({ success: false, data: null });
                    }
                }
            } else {
                if (typeof callback === 'function') {
                    callback({ success: false, data: null });
                }
            }
        });
    }

    getCombinedPromotions(promotionId, coursesHeadingsId, productId, callback) {
        const payload = {
            promotionsSalesID: promotionId,
            coursesHeadingsID: coursesHeadingsId,
            productsID: productId,
        };

        this.apiService.apiPost(
            'GetCombinedPromotionsForCurrentPromotionsID',
            payload,
            (response) => {
                if (response.success) {
                    if (response.data.status === '200') {
                        const combinedPromotionIds = [];
                        for (const promo of response.data.body) {
                            if (
                                typeof promo.combined_PromotionsSalesID === 'number' &&
                                promo.combined_PromotionsSalesID > 0
                            ) {
                                combinedPromotionIds.push(promo.combined_PromotionsSalesID);
                            }
                        }

                        if (typeof callback === 'function') {
                            callback({ success: true, data: combinedPromotionIds });
                        }
                    } else {
                        if (typeof callback === 'function') {
                            callback({ success: false, data: null });
                        }
                    }
                } else {
                    if (typeof callback === 'function') {
                        callback({ success: false, data: null });
                    }
                }
            }
        );
    }

    prepareDiscounts(promotionsList, inInstallments) {
        const removeDuplicates = (originalArray, prop) => {
            const newArray = [];
            const lookupObject = {};

            originalArray.forEach((item, index) => {
                lookupObject[originalArray[index][prop]] = originalArray[index];
            });

            Object.keys(lookupObject).forEach((element) => {
                newArray.push(lookupObject[element]);
            });
            return newArray;
        };

        const filteredPromos1 = [];
        promotionsList.forEach((item) => {
            if (this.validateDiscountByPaymentType(item, inInstallments)) {
                filteredPromos1.push(item);
            }
        });

        const filteredPromos2 = removeDuplicates(filteredPromos1, 'promotionsSalesID');

        const filteredPromos3 = [];
        filteredPromos2.forEach((elem) => {
            const { promotionsSalesID, promotionsSalesName, activationTypeDVID } = elem;
            elem = {
                promotionsSalesID,
                promotionsSalesName,
                activationTypeDVID,
                // isCheckedForCombined: false,
            };
            // elem.displayPromotionButton = true;
            filteredPromos3.push(elem);
        });

        filteredPromos3.forEach((elem) => {
            const array = [];
            promotionsList.forEach((item) => {
                if (
                    elem.promotionsSalesID == item.promotionsSalesID &&
                    this.validateDiscountByPaymentType(item, inInstallments)
                ) {
                    item.displayPromotionButton = true;
                    array.push(item);
                }
                // this.validateDiscountForPayment(item)
            });
            elem.discounts = array;
            elem.showDiscounts = false;
        });

        return filteredPromos3;
    }

    validateDiscountByPaymentType(item, inInstallments) {
        if (
            typeof item === 'object' &&
            item !== null &&
            typeof item.discountsDefinitionsID === 'number' &&
            item.discountsDefinitionsID > 0
        ) {
            let acceptedIds = null;

            if (inInstallments) {
                acceptedIds = [1, 3, 4, 5, 8, 9, 10, 11, 12, 13];
            } else {
                acceptedIds = [1, 2, 6, 7, 12, 13];
            }

            return acceptedIds.includes(item.discountsDefinitionsID);
        } else return false;
    }
}
